export const MAX_UPLOAD_SIZE = 1048576 * 1024; // 1048576 bits == 1 MB so max file upload is 1 GB

const LANGUAGE_CODES_LIST = {
  Afrikaans: "af",
  Albanian: "sq",
  Amharic: "am",
  Arabic: "ar",
  Armenian: "hy",
  Azerbaijani: "az",
  Bengali: "bn",
  Bosnian: "bs",
  Bulgarian: "bg",
  Catalan: "ca",
  "Chinese (Simplified)": "zh",
  "Chinese (Traditional)": "zh-TW",
  Croatian: "hr",
  Czech: "cs",
  Danish: "da",
  Dari: "fa-AF",
  Dutch: "nl",
  English: "en",
  Estonian: "et",
  "Farsi (Persian)": "fa",
  "Filipino, Tagalog": "tl",
  Finnish: "fi",
  French: "fr",
  "French (Canada)": "fr-CA",
  Georgian: "ka",
  German: "de",
  Greek: "el",
  Gujarati: "gu",
  "Haitian Creole": "ht",
  Hausa: "ha",
  Hebrew: "he",
  Hindi: "hi",
  Hungarian: "hu",
  Icelandic: "is",
  Indonesian: "id",
  Irish: "ga",
  Italian: "it",
  Japanese: "ja",
  Kannada: "kn",
  Kazakh: "kk",
  Korean: "ko",
  Latvian: "lv",
  Lithuanian: "lt",
  Macedonian: "mk",
  Malay: "ms",
  Malayalam: "ml",
  Maltese: "mt",
  Marathi: "mr",
  Mongolian: "mn",
  "Norwegian (Bokmål)": "no",
  Pashto: "ps",
  Polish: "pl",
  "Portuguese (Brazil)": "pt",
  "Portuguese (Portugal)": "pt-PT",
  Punjabi: "pa",
  Romanian: "ro",
  Russian: "ru",
  Serbian: "sr",
  Sinhala: "si",
  Slovak: "sk",
  Slovenian: "sl",
  Somali: "so",
  Spanish: "es",
  "Spanish (Mexico)": "es-MX",
  Swahili: "sw",
  Swedish: "sv",
  Tamil: "ta",
  Telugu: "te",
  Thai: "th",
  Turkish: "tr",
  Ukrainian: "uk",
  Urdu: "ur",
  Uzbek: "uz",
  Vietnamese: "vi",
  Welsh: "cy",
  Default: "default",
};

export const LANGUAGE_CODES = Object.fromEntries(
  Object.entries(LANGUAGE_CODES_LIST).map(([name, code]) => [code, name]),
);

export const AI_ICON_RESTRICTED_ENTITY_IDS = ["org_76169c2c-8517-4689-91bc-a64bee36df73"];

export const HIGHLIGHT_KNOWN_ERROR_MESSAGES = ["Title already exists"];

export const CLIP_OPERATIONS = {
  CUT: "cut",
  TRIM: "trim",
};

export const CORE_FIELD_SCOPES = {
  CLIP_TAGGING: "clip_tagging",
  STREAM: "stream",
};
